import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, MenuItem,
  Menu,
  Stack, Button,
  InputBase, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { Filter } from '../../Svg';
import { time } from "../../utils/timeAgo"
import { setFilterValues } from '../../redux/scheduledOrders';


// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: '1px solid #E6E1E5',
  padding: '4px 40px',
  fontSize: '14px',
  color: '#667085',
}));

const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));
const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 0px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '0px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '0px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const Reschedule = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ECE74833',
  color: '#ECE748',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Pending = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'orange',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Cancelled = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'red',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const Await = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));



const AllScheduleOrderTable = ({ scheduleData, page, setPage, itemsPerPage, start, end, totalItems, handleOpenMenu }) => {



  const [catAnchorEl, setCatAnchorEl] = useState(null); // State for Category dropdown

  const [statusAnchorEl, setStatusAnchorEl] = useState(null); // State for Status dropdown
  const statusOpen = Boolean(statusAnchorEl);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);
  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);



  // Handlers for Category dropdown
  const handleCatClick = (event) => {
    setCatAnchorEl(event.currentTarget);
  };

  const handleCatClose = () => {
    setCatAnchorEl(null);
  };

  // Handlers for Status dropdown
  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusClose = () => {
    setStatusAnchorEl(null);
  };


  const dispatch = useDispatch()
  const navigate = useNavigate()



  //edit
  const handleEditClick = (category) => {
    dispatch(setEditCategory(category));
    navigate('/master/editCategory')
  };

  const handleSearch = (e) => {
    dispatch(setFilterValues({ search: e.target.value, page: 1 }))
  }

  //delete
  const deleteCategory = () => {
    dispatch(deleteCategoriesThunk(selectedId))
    setIsModalOpen(false);

  }


  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const formatScheduleDate = (day) => {
    const date = Number(day);
    if (!Number.isInteger(date) || date < 1 || date > 31) return 'Not set';
    const suffix = [11, 12, 13].includes(date % 100)
      ? 'th'
      : ({ 1: 'st', 2: 'nd', 3: 'rd' }[date % 10] || 'th');
    return `${date}${suffix} of every month`;
  };

  const getPaymentMethod = (row) => row?.paymentMethod || row?.payment?.method || 'Offline';





  return (
    <>




      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell sx={{ paddingLeft: "20px" }}>
                Order ID
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Schedule Date
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Customer
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Total
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Payment
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Last Dispatch
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu(e, 'Status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {scheduleData?.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ paddingLeft: "20px", width: '12%' }}>{row?._id}</ProductText>

                <TableCells sx={{
                  width: '16%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{formatScheduleDate(row?.scheduleDate)}</strong>
                    </div>
                  </div>
                </TableCells>

                {/* <ProductText sx={{ width: '10%' }}>{row?.user?.fullName}</ProductText> */}

                <TableCells sx={{
                  width: '14%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.companyName || row?.user?.fullName || 'Customer unavailable'}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.fullName || row?.user?.email || 'No customer profile linked'}
                      </div>
                    </div>
                  </div>
                </TableCells>


                <TableCells sx={{
                  width: '14%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        ₹ {row?.priceBreakup?.total}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <TableCells sx={{ width: '10%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {getPaymentMethod(row)}
                </TableCells>

                <TableCells sx={{ width: '10%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row?.products[0]?.lastDeliveryDate)}
                </TableCells>


                <TableCells sx={{ width: '10%' }}>
                  {row?.status === "APPROVED" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "COMPLETED" ? (
                    <Delivered label="Completed" size="small" />
                  ) : row?.status === "DISPATCHED" ? (
                    <Processing label="DISPATCHED" size="small" />
                  ) : row?.status === "RESCHEDULE" ? (
                    <Reschedule label="Reschedule" size="small" />
                  ) : row?.status === "APPROVED" ? (
                    <Shiped label="APPROVED" size="small" />
                  ) : row?.status === "COMPLETED" ? (
                    <Processing label="COMPLETED" size="small" />
                  ) : row?.status === "PENDING" ? (
                    <Pending label="PENDING" size="small" />
                  ) : row?.status === "AWAITING" ? (
                    <Await label="Awaiting dispatch" size="small" />
                  ) : (<Cancelled label="CANCELLED" size="small" />)}
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/schedule/scheduleOrderDetails/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'category'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllScheduleOrderTable;
